// extracted by mini-css-extract-plugin
export default {"filtersAndList":"AdminsTab_filtersAndList__3O-Jm","foundedCount":"AdminsTab_foundedCount__42n8j"};